import { render, staticRenderFns } from "./DailyPlan.vue?vue&type=template&id=20420a8e"
import script from "./DailyPlan.vue?vue&type=script&lang=ts"
export * from "./DailyPlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports